import React from "react";
import { Box, Typography } from "@mui/material";
import { BACKGROUND_COLOR, FONT_SIZE } from "../GoFurtherStyles";

type CreateGoFurtherTooltipOptions = {
  allowedDataKeys?: string[];
  getUnit?: (dataKey: string) => string;
  fontSize?: string | number;
  roundValue?: boolean;
};

export const formatGoFurtherTooltipValue = (value: unknown, roundValue = true): string => {
  if (value == null) return "-";

  const numeric = Number(value);
  if (!Number.isNaN(numeric) && Number.isFinite(numeric)) {
    const formatted = roundValue ? Math.round(numeric) : numeric;
    return formatted.toLocaleString("ja-JP");
  }

  return String(value);
};

export const createGoFurtherTooltip = ({
  allowedDataKeys,
  getUnit,
  fontSize = FONT_SIZE.caption,
  roundValue = true,
}: CreateGoFurtherTooltipOptions): React.FC<any> => {
  const allowed = allowedDataKeys ? new Set(allowedDataKeys) : null;

  const TooltipContent: React.FC<any> = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length) return null;

    const visiblePayload = allowed
      ? payload.filter((entry: any) => entry && typeof entry.dataKey === "string" && allowed.has(entry.dataKey))
      : payload;

    if (!visiblePayload.length) return null;

    return (
      <Box
        sx={{
          p: 2,
          bgcolor: BACKGROUND_COLOR.WHITE,
          border: `1px solid ${BACKGROUND_COLOR.INHERIT}`,
          borderRadius: 1.5,
          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.08)",
          "& > :not(style) + :not(style)": { mt: 1 },
        }}
      >
        <Typography sx={{ display: "block", fontSize }}>{label}</Typography>
        {visiblePayload.map((entry: any) => {
          const unit = getUnit ? getUnit(String(entry.dataKey)) : "";
          const valueText = formatGoFurtherTooltipValue(entry?.value, roundValue);
          return (
            <Typography
              key={entry.dataKey}
              sx={{ display: "block", color: entry.color || "inherit", fontSize }}
            >
              {entry.name}: {valueText}
              {unit ? ` ${unit}` : ""}
            </Typography>
          );
        })}
      </Box>
    );
  };

  return TooltipContent;
};
